import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { getItemCategories, clearItemCategories } from '../../../../actions';

const ItemCategorySelect = ({
  loading,
  itemCategoryOptions,
  isGridVariant,
  value,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetItemCategories,
  dispatchClearItemCategories,
  cleanWhenUnmount,
  isSpecial,
  isRegular,
  ...rest
}) => {
  const storeKey = isSpecial ? 'special' : 'regular';

  useLayoutEffect(() => {
    const query = {
      ...DEFAULT_QUERY_GET_ALL,
      query: ['active:true'],
    };

    if (isSpecial !== undefined) {
      query.query.push(`isSpecial:${isSpecial}`);
    }

    if (isRegular !== undefined) {
      query.query.push(`isRegular:${isRegular}`);
    }

    dispatchGetItemCategories(query, storeKey);

    return () => {
      if (cleanWhenUnmount) dispatchClearItemCategories(storeKey);
    };
  }, []);

  return (
    <Select
      isLoading={loading}
      options={itemCategoryOptions}
      isMulti={isMulti}
      input={{ value }}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

ItemCategorySelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetItemCategories: PropTypes.func.isRequired,
  dispatchClearItemCategories: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  itemCategoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
    }),
  ).isRequired,
  isClearable: PropTypes.bool,
  sortByName: PropTypes.bool,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  cleanWhenUnmount: PropTypes.bool,
  isSpecial: PropTypes.bool,
  isRegular: PropTypes.bool,
};

ItemCategorySelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  isClearable: false,
  onValueChange: undefined,
  value: {},
  cleanWhenUnmount: true,
  isSpecial: undefined,
  isRegular: undefined,
  sortByName: false,
};

const mapStateToProps = ({ BaggageUnit }, { isSpecial, sortByName }) => {
  const storeKey = isSpecial ? 'special' : 'regular';

  const itemCategoryOptions = BaggageUnit.ItemCategory.getIn([
    storeKey,
    'content',
    'content',
  ]);

  const options = [];
  itemCategoryOptions.forEach((itemCategory) => {
    options.push({
      value: itemCategory.id,
      label: itemCategory.name,
    });
  });

  if (sortByName) {
    options.sort((a, b) => a.label.localeCompare(b.label));
  }

  return {
    itemCategoryOptions: options,
    loading: BaggageUnit.ItemCategory.getIn([storeKey, 'loading']),
  };
};

const mapDispatchToProps = {
  dispatchGetItemCategories: getItemCategories,
  dispatchClearItemCategories: clearItemCategories,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemCategorySelect);
